module.exports = __webpack_public_path__ + "img/organ.49aa861b.png";